var map = {
	"./about.ts": "188b",
	"./accopmany.ts": "24eb",
	"./business.ts": "904d",
	"./co-creation-club.ts": "e4b6",
	"./digitalization.ts": "e611",
	"./home.ts": "6b72",
	"./scientific-management.ts": "7395"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "795e";